<template>
    <div class="modal">
        <section class="section">
            <h1 class="section__title">
                <!-- Get riches in Corgi Pharaoh -->
                {{ $t('pharaoh.sectionTitle') }}
            </h1>
            <h2 class="section__subtitle h3">
                <!-- Play the New Original Slot! -->
                {{ $t('pharaoh.sectionSubtitle') }}
            </h2>
            <!-- ↑标题 -->
            <!-- ↓图像 -->
            <picture class="section__img" >
                <source media="(min-width: 1100px)" srcset="@/pages/casino/corgipharaohGame/img/introduction/devices_2x.png" />
                <img src="@/pages/casino/corgipharaohGame/img/introduction/devices__mob_2x.webp" alt="benefits" />
            </picture>
            <!-- ↓ -->
            <div class="section__content">
                <p class="section__text">
                    <!-- Experience the thrill of the new Original Slot with an exciting Bonus
                    game. Enjoy high winnings, a multiplier feature, and a hot Egypt
                    atmosphere. Spin the reels across 5 paylines and discover the secrets of
                    the pharaohs. -->
                    {{ $t('pharaoh.sectionText') }}
                </p>
            </div>
        </section>

        <section class="section --center">
            <h1 class="section__title">
                <!-- Experience unique Gameplay -->
                {{ $t('pharaoh.title2') }}
            </h1>
            <div class="section__content">
                <p class="section__text">
                    <!-- Discover the power of the ancient world - play Corgi Pharaoh and enjoy amazing features! -->
                    {{ $t('pharaoh.text2') }}
                </p>
                <picture class="section__text-img" >
                    <source media="(min-width: 1100px)" srcset="@/assets/imgs/introduction/benefits_2x.png" />
                    <img src="@/assets/imgs/introduction/benefits_mob_2x.webp" alt="benefits" />
                </picture>
            </div>
        </section>
    </div>
</template>


<script>
export default {
    name: 'contentPharaoh', 
}
</script>


<style lang="scss" scoped>
.controls {
    display: flex;
    gap: 12px
}

.control--close {
    background-color: var(--color_grey-60) !important;
    color: var(--color_grey-20) !important
}

.control--close:hover {
    background-color: var(--color_grey-80) !important
}

.control--close:active {
    background-color: var(--color_grey-100) !important
}

.modal {
    background: linear-gradient(169.15deg,#362589 2.9%,#190d46 22.15%,#011a7400 38.46%),#0c0f1c;
    --inline: 24px;
    margin-left: calc(-1 * var(--inline));
    margin-right: calc(-1 * var(--inline));
    padding-left: var(--inline);
    padding-right: var(--inline);
    position: relative;
}

// ↓追加
// .modal > .section{
//     min-height: 100px;
// }

.modal:before {
    content: "";
    background: url(@/pages/casino/corgipharaohGame/img/introduction/bg_2x.png);
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background-position-x: center; // 追加 
}

@media (max-width: 1099px) {
    .modal:before {
        background:url(@/pages/casino/corgipharaohGame/img/introduction/bg_mobile_2x.png);
        background-repeat: no-repeat;
        background-size: contain;
        background-position-x: center; // 追加 
        background-position-y: bottom; // 追加，便移动端的时候把图沉底 
    }
}

.modal {
    display: flex;
    flex-direction: column;
    gap: 144px
}

@media (max-width: 1099px) {
    .modal {
        gap:56px
    }
}

.section {
    position: relative;
    z-index: 1
}

@media (max-width: 1099px) {
    .section {
        display:grid;
        grid-template-areas: "title" "subtitle" "image" "content";
    }
}

.section:first-child {
    margin-top: 107px
}

@media (max-width: 1099px) {
    .section:first-child {
        margin-top:73px
    }
}

.section__img {
    grid-area: image;
    height: 345px;
    -o-object-fit: cover;
    object-fit: cover;
    position: absolute;
    right: -24px;
    top: -107px;
    width: 345px
}

@media (max-width: 1099px) {
    .section__img {
        display:block;
        height: auto;
        left: auto;
        margin-left: -26px;
        margin-right: -26px;
        position: static;
        right: auto;
        width: calc(100% + 52px)
    }
}

.section__content {
    grid-area: content;
    max-width: 50%
}

@media (max-width: 1099px) {
    .section__content {
        max-width:100%;
        text-align: center
    }
}

.section__title {
    font-size: 18px;
    font-weight: 600;
    grid-area: title;
    letter-spacing: -.02em;
    line-height: 135%;
    margin-bottom: 0;
    max-width: 50%;
    // white-space: pre-wrap;
}

@media (max-width: 1099px) {
    .section__title {
        margin-bottom:0;
        // max-width: 302px;
        margin-inline: auto;
        max-width: 90%;
        text-align: center;
    }
}

.section__subtitle {
    margin-bottom: 12px;
    // ↓追加
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -.02em;
    line-height: 28px;
    margin-top: 0;
}

@media (max-width: 1099px) {
    .section__subtitle {
        margin-bottom:0;
        margin-inline: auto;
        // max-width: 302px;
        max-width: 90%;
        text-align: center
    }
}

.section:first-child .section__title {
    color: #df9bff;
    font-size: 24px
}

.section:first-child .section__text {
    margin: 0
}

@media (max-width: 1099px) {
    .section:first-child .section__text {
        margin-bottom:8px
    }
}

.section:first-child .section__text-img {
    margin-top: 24px
}

@media (max-width: 1099px) {
    .section:first-child .section__img {
        margin-bottom:12px
    }
}

.section:last-child {
    margin-bottom: 0;
    margin-top: -32px
}

@media (max-width: 1099px) {
    .section:last-child {
        margin-top:4px
    }
}

.section:last-child .section__title {
    max-width: 100%
}

@media (max-width: 1099px) {
    .section:last-child .section__title {
        margin-bottom:0
    }
}

.section:last-child .alert {
    align-items: center;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background: #00000024;
    border: 1px solid rgba(0,0,0,.04);
    border-radius: 10px;
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    padding: 6px 9px
}

@media (max-width: 1099px) {
    .section:last-child .alert {
        margin-bottom:10px
    }
}

.section:last-child .alert__icon {
    display: block;
    min-height: 36px;
    min-width: 36px
}

.section:last-child .alert__text {
    font-size: 12px;
    line-height: 150%;
    margin: 0
}

@media (max-width: 1099px) {
    .section:last-child .alert__text {
        text-align:left
    }
}

.section:last-child .alert.hidden {
    visibility: hidden
}

.section__text {
    color: var(--color_grey-20);
    font-size: 12px;
    font-weight: 500;
    line-height: 150%
}

.section__text-img {
    margin-top: 72px
}

.section.--center {
    margin-bottom: 408px
}

.section.--center .section__text-img {
    margin-inline: auto
}

@media (max-width: 1099px) {
    .section.--center .section__text-img {
        margin-top:32px;
        max-width: 109px
    }
}

.section.--center .section__title {
    margin-bottom: 12px;
    max-width: none;
    text-align: center
}

.section.--center .section__content {
    max-width: 100%;
    text-align: center
}

.section.--center .section__text {
    margin-bottom: 26px;
    white-space: pre-wrap
}

@media (max-width: 1099px) {
    .section.--center .section__text {
        margin-bottom:42px;
        white-space: normal
    }
}

.section.--center .section__text-img {
    margin-bottom: -52px
}


</style>

